// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__1tAB7","topBottomGutter":"Layout_topBottomGutter__1_jUy"};